import React, { ReactElement, ReactNode } from "react";
import Head from "next/head";
import Footer from "@components/shared/footer";
import Modal from "@components/shared/modal";
import CloseIcon from "@components/svg/closeIcon";
import PrivacyPolicy from "@components/shared/legal/privacyPolicy";
import TermsAndConditions from "@components/shared/legal/termsAndConditions";
import { useModal } from "@hooks/useModalContext";
import Header from "@components/shared/header";
import TopBusinessQuotesLogo from "@components/topbusinessquotes/logo";
import Mobile from "@components/shared/blogPost/sideWidget/mobile";

export default function TopBusinessQuotesWrapper({
    children,
}: {
    children: ReactNode;
}): ReactElement {
    const { modal, closeModal } = useModal();

    const handleClose = () => {
        closeModal();
    };

    const { active: modalActive, content: modalContent } = modal;

    const getModalContent = () => {
        switch (modalContent) {
            case "privacy":
                return (
                    <PrivacyPolicy
                        category="Business"
                        domain="TopBusinessQuotes.com"
                    />
                );
            case "terms":
                return (
                    <TermsAndConditions
                        category="Business"
                        domain="TopBusinessQuotes.com"
                    />
                );
            case "sideWidget":
                return <Mobile />;
            default:
                return null;
        }
    };

    return (
        <>
            <Head>
                <link rel="preconnect" href="https://fonts.googleapis.com" />
                <link rel="preconnect" href="https://fonts.gstatic.com" />

                <link
                    href="https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700&display=swap"
                    rel="stylesheet"
                ></link>
            </Head>

            <div style={{ fontFamily: `'Inter', sans-serif` }}>
                <Header
                    slogan="all your business needs in one place"
                    phoneNumberColor="#063C58"
                    iconColor="#063C58"
                >
                    <TopBusinessQuotesLogo />
                </Header>
                <main className="max-w-7xl mx-auto block px-6vw lg:px-4">
                    {children}
                </main>
                <Footer bgColor="#F2F2F2" />

                <Modal
                    onClose={handleClose}
                    active={modalActive}
                    closeIcon={<CloseIcon />}
                    backdropClosable
                    modalStyles={{
                        display: "flex",
                        flexDirection: "column",
                        maxHeight:
                            modalContent === "sideWidget" ? "80vh" : "100%",
                    }}
                    modalClassName="h-[90vh] rounded"
                    bodyStyles={{ overflowY: "scroll" }}
                    width={900}
                    header={
                        modalContent === "privacy"
                            ? "Privacy Policy"
                            : modalContent === "terms"
                            ? "Terms and Conditions"
                            : modalContent === "sideWidget"
                            ? "Contents"
                            : undefined
                    }
                >
                    {getModalContent()}
                </Modal>
            </div>
        </>
    );
}
